import { TEMPLATES } from "utils/constants";
import AdherentInfo from "../RadianceCosa/AdherentInfo";
import AdherentTelecoms from "../RadianceCosa/AdherentTelecoms";
import Loading from "../RadianceCosa/Components/Spin";
import ContactUsBase from "../RadianceCosa/ContactUs";
import SubscriptionContract from "../RadianceCosa/Contract";
import Default from "../RadianceCosa/Default";
import ElectronicSignature from "../RadianceCosa/ElectronicSignature";
import Justification from "../RadianceCosa/Justification";
import Needs from "../Radiance/Needs";
import NoSubscriptionBase from "../RadianceCosa/NoSubscription";
import Payment from "../RadianceCosa/Payment";
import ProductsBase from "../RadianceCosa/Products";
import Subscription from "../RadianceCosa/Subscription";
import SubscriptionDone from "../RadianceCosa/SubscriptionDone";

const isAuraTer = true;

const withAuraTer = (Component) => {
  const Wrapped = (props) => <Component {...props} isAuraTer={isAuraTer} />;
  Wrapped.displayName = `WithAuraTer(${
    Component.displayName || Component.name || "Component"
  })`;
  return Wrapped;
};

const Products = withAuraTer(ProductsBase);
const ContactUs = withAuraTer(ContactUsBase);
const NoSubscription = withAuraTer(NoSubscriptionBase);

const Templates = {
  Loading: <Loading />,
  [TEMPLATES.B2C.THEMES.RADIANCE.PAYMENT]: Payment,
  [TEMPLATES.B2C.THEMES.RADIANCE.B2C_SUBSCRIPTION]: Subscription,
  [TEMPLATES.B2C.THEMES.RADIANCE.B2C_SUBSCRIPTION_CONTRACT]:
    SubscriptionContract,
  [TEMPLATES.B2C.THEMES.RADIANCE.NEEDS]: Needs,
  [TEMPLATES.B2C.THEMES.RADIANCE.B2C_SUBSCRIPTION_DONE]: SubscriptionDone,
  [TEMPLATES.B2C.THEMES.RADIANCE.JUSTIFICATIONS]: Justification,
  [TEMPLATES.B2C.THEMES.RADIANCE.ADHERENT_INFO]: AdherentInfo,
  [TEMPLATES.B2C.THEMES.RADIANCE.ADHERENT_TELECOMS]: AdherentTelecoms,
  [TEMPLATES.B2C.THEMES.RADIANCE.PRODUCTS]: Products,
  [TEMPLATES.B2C.THEMES.RADIANCE.CONTACT_US]: ContactUs,
  [TEMPLATES.B2C.THEMES.RADIANCE.NO_SUBSCRIPTION]: NoSubscription,
  [TEMPLATES.B2C.THEMES.RADIANCE.E_SIGN]: ElectronicSignature,
  default: Default,
};
export default Templates;
